import type { ChipProps } from "@mui/material";
import { Chip, Typography, styled } from "@mui/material";
import { FormattedMessage } from "react-intl";

import { StarburstIcon } from "../icons";

const StyledChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.data.background,
  border: `1px solid ${theme.palette.data[100]}`,
  color: theme.palette.data.dark,
}));

export function OmniChip({ size = "small" }: { size?: ChipProps["size"] }) {
  return (
    <StyledChip
      icon={<StarburstIcon color="data" />}
      label={
        <Typography variant="overline">
          <FormattedMessage id="Omni" />
        </Typography>
      }
      size={size}
    />
  );
}
